<template>
  <div>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row justify="center" align="start">
          <v-col>
            <message-iframe v-if="!overlay && !openPlayerNameDialog" ref="iframe" :fullscreen="true" :src="src"
                            @message="receiveMessage" />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <player-name-dialog v-if="isScoreSendingEnabled" v-model="openPlayerNameDialog" @update="changePlayerName" />
  </div>
</template>

<script>
import MessageIframe from "src/components/MessageIframe";
import { types as GameTypes } from "src/store/modules/Game.module";
import { types as GameLogTypes } from "src/store/modules/GameLog.module";
import { types as ScoreTypes } from "src/store/modules/Score.module";
import GameDataService from "src/services/GameDataService";
import PlayerNameDialog from "src/view/play/PlayerNameDialog";
import { isRtl } from "src/locales"

export default {
  name: "PlayView",
  components: { PlayerNameDialog, MessageIframe },
  props: [],
  data() {
    return {
      overlay: true,
      gameData: {},
      openPlayerNameDialog: false,
      playerName: "",
      reload: 1,
      isRtl,
      isInIframe: window !== window.parent
    };
  },
  computed: {
    game() {
      return this.$store.state.GameModule.game;
    },
    auth() {
      return this.$store.state.AuthModule.user;
    },
    src() {
      let search = new URLSearchParams(location.search);
      search.append("game", "true");
      search.append("key", "1");
      search.append("reload", this.reload);
      if (this.game.type.can_live_edit != 1) {
        search.append('desktopView', 'true');
      }
      if (this.gameData.setting.hide_animation)
        search.append('hide_ani', 'true');
      // console.log(this.game);
      //if (this.game.type.can_live_edit) {
      //	search.append("desktopView", "true");
      //}
      // search.append("desktopView", "true");
      if (this.game.type && this.game.type.preview_iframe_override != null && this.game.type.preview_iframe_override != 'null')
        return this.game.type.preview_iframe_override + "&" + search.toString();
      else
        return `https://pashframe.closeapp.co.il/games/indexEditModeZim2.html?${search.toString()}`;
      // return "http://shabat.test/indexEditMode.html?game=true&key=1";
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    parentUrl() {
      return (window.location !== window.parent.location)
          ? document.referrer
          : document.location.href;
    },
    isScoreSendingEnabled() {
      return this.game.store_score && this.game.type.can_live_edit
    }
  },
  watch: {},
  async created() {
    try {
      await this.$store.dispatch(GameTypes.GET, this.$route.params.id);
      if (!this.game.share) {
        await this.showDraftPopup();
      }

      this.gameData = await GameDataService.get(this.$route.params.id);
      /* not count managers play */
      if (!this.isManager) {
        setTimeout(() => {
          const gameLog = { game_id: this.$route.params.id };
          this.$store.dispatch(GameLogTypes.SAVE, gameLog);
        }, 10000);
      }
      if (this.isScoreSendingEnabled && !this.auth.name) {
        this.openPlayerNameDialog = true;
      }
      this.overlay = false;
    } catch (e) {
      // eslint-disable-next-line no-undef
      await this.$notification.error(
          "ללא הרשאת גישה",
          "אנא פנה למנהל המערכת"
      ).then(() => {
        window.location.replace("/");
      });
    }
    // setTimeout(() => {
    //   this.sendScore({})
    // }, 2000)
  },
  methods: {
    changePlayerName(playerName) {
      this.playerName = playerName;
    },
    receiveMessage(event) {
      if (event.action && this[event.action] && typeof this[event.action] === 'function') {
        this[event.action](event);
      }

      if (this.isInIframe) { // if the game is in iframe, send the event to the parent window
        this.sendEventToParent(event);
      }
    },
    /**
     * send the event to the parent window, when the game is in iframe (e.g. in OrQuize or other platforms)
     */
    sendEventToParent(event) {
      const allowedOrigins = [
        'https://stage.closeapp.orquiz.clap.co.il',
        'https://orquiz-game.clap.co.il',
        'http://localhost:3000',
        'http://localhost:5173'
      ];
      const targetOrigin = document.referrer && allowedOrigins.find(origin => document.referrer.startsWith(origin));

      window.parent.postMessage(
          { type: 'claplab-message', data: event },
          targetOrigin
      );
    },
    iframeReady() {
      this.$refs.iframe.postMessageCustom({
        action: "getJson",
        json: this.gameData,
        language: this.$i18n.locale
      });
    },
    finishTheGame(event) {
      console.log(event);
      if (event.origin !== window.location.href) {
        this.$emit("finishTheGame");
        this.$store.dispatch("", event);
        // we should save game score
        if (this.isScoreSendingEnabled) {
          this.sendScore(event);
        }
        window.top.postMessage({
          action: "finishTheGame",
          score: event.score,
          origin: window.location.href,
        }, this.parentUrl);
      }
    },
    isCollectScore(event) {
      if (this.game.store_score) {
        this.$refs.iframe.postMessageCustom({
          action: "collectScore"
        });
      }
    },
    sendScore(event) {
      let score = {
        game_id: this.game.id,
        user_name: this.auth?.name || this.playerName,
        time: event.time,
        score: Math.round(event.score)
      }

      this.$store.dispatch(ScoreTypes.SAVE, score)
    },
    openUsernameDialog() {
      this.openPlayerNameDialog = true;
    },
    async showDraftPopup() {
      const direction = this.isRtl() ? 'rtl' : 'ltr';
      try {
        let { value } = await this.$notification.question(
            this.$t("generics.draft_mode"),
            "",
            {
              html: `
               <div style="direction: ${direction} !important;"><strong>${this.$t("generics.out_side_the_editor")}</strong>
            </br>
            ${this.$t("generics.turn_active_mode")}?</div>
            `,
              icon: "question",
              confirmButtonColor: "#ED217C",
              confirmButtonText: "OK",
              showCloseButton: false,
              showDenyButton: true,
              allowOutsideClick: false,
              denyButtonText: this.$t("generics.not_yet"),
            },
        );
        if (value) {
          this.$store.dispatch(GameTypes.SAVE, Object.assign(this.game, { share: true }));
        }
        return true;
      } catch (e) {
        console.log(e);
      }
    },
    needRefresh() {
      this.reload++;
    }
  }
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center
}
</style>
